import React from "react";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BASE_API_URL } from "../../constant";
import tringlogo from "../../images/tring.png";

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const resp = await axios.post(BASE_API_URL + "api/admin/login", {
                email,
                password,
            });
            localStorage.setItem("token", resp.data.data.token);

            localStorage.setItem("adminData", resp.data.data.email);
            navigate("admin/dashboard");
        } catch (err) {
            alert(err.response.data.msg);
        }
    }

    return (
        <div className="d-flex justify-content-center align-items-cemter bg-secondary vh-100">
            <div className="bg-white p-3 rounded w-40">
                <div className="mb-5">
                    <img src={tringlogo} alt="tring-logo" />
                </div>
                <h2 className="text-center">Login</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3">
                        <label htmlFor="email">Email</label>
                        <input type="email" className="form-control" id="email" placeholder="Enter Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="form-group mb-3">
                        <label htmlFor="password">Password</label>
                        <input type="password" className="form-control" id="password" placeholder="Enter Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <button type="submit" className="btn btn-success w-100 rounded-0">Login</button>
                </form>
            </div>
        </div>
    )
}
export default Login;